import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';

// import Ecom from '@wayke-se/ecom-react';
// import '@wayke-se/ecom-react/assets/styles/default.css'
// import Ecom from '@wayke-se/ecom-web';
// import WaykeEcomWeb from '@wayke-se/ecom-web';
// import '@wayke-se/ecom-web/dist/index.css';
import WaykeEcomWrapper from './WaykeEcomWrapper';


import findImageFormat from '../helpers/findImageFormat'
import { TagManager } from '../helpers/TagManager'
import carResource from '../helpers/CarResource'
import imboxToggle from '../helpers/imboxToggle'

import CarCard from './partials/CarCard'
import Gallery from './partials/car/Gallery'
import Keywords from './partials/car/Keywords'
import BuyingOptions from './partials/car/BuyingOptions'
import EnhancedProperties from './partials/car/EnhancedProperties'
import Expanding from './partials/car/Expanding'
import LoanCalc from './partials/car/LoanCalc';
import InfoModal from './partials/InfoModal';

import Cost from './partials/car/Cost';
import CarJSONLD from './json-ld/CarJSONLD';
import CarFax from './partials/car/CarFax';
import WPBlocks from './partials/WPBlocks'

import AppContext from '../components/context/AppContext'
import CarContext from '../components/context/CarContext'
import MobileMenu from './partials/car/MobileMenu';
import FeaturedImagePlaceholder from './partials/car/FeaturedImagePlaceholder';
import useQueryString from '../hooks/useQueryString';
import breakPoints from '../helpers/breakPoints';
import UspDetails from './partials/car/UspDetails';
import Location from './partials/car/Location';
import BegTest from './partials/car/BegTest';
import Warranty from './partials/car/Warranty';
import DealsSection from './partials/car/DealsSection';
import AutokuvaWrapper from './partials/car/Autokuva';

const Car = ({ path }) => {
	const { slug } = useParams()
	const history = useHistory();
	const { client } = useContext(AppContext);
	const [car, setCar] = useState(false)
	const [related, setRelated] = useState(false)
	const [order, setOrder] = useState(false)
	const [campaigns, setCampaigns] = useState(false)
	const [lastViewedCars, setLastViewedCars] = useState(false)
	const [shouldShowEcomModal, setShouldShowEcomModal] = useState(false)
	const [modal, setModal] = useState({ show: false, title: false, text: false })
	const [queryString, setQueryString] = useQueryString(useLocation().search);
	const [tradeIn, setTradeIn] = useState(false)
	const [ecomData, setEcomData] = useState({
		vehicle: {
			id: '',
			title: '',
			shortDescription: '',
			price: '',
			imageUrl: '',
			retailerName: '',
			modelYear: 0,
			milage: '',
			gearBox: '',
			fuelType: ''
		},
		serviceLogotypeUrl: '',
		onExit: ()=>{ setShouldShowEcomModal(false); },
		onUserEvent: (e,step)=>{ console.log(e,step); },
		useBankId: true,
		displayBankIdAlert: true	
	})

	/* Wayke handle event functions */
	const handleWaykeBuyButton = useCallback((startEcom) => {
		startEcom();
	}, []);

	const handleWaykeModalClose = useCallback(() => {
		setShouldShowEcomModal(false);
	}, []);

	let hasTriggeredEquipment = false

	const findIdFromSlug = (slug) => {
		return slug.split('--')[1]
	}

	const addToLocalStorage = (car) => {
		if (!car) {
			return false
		}

		const key = 'bbLastViewedCars'
		const carSrc = carResource(car)
		let storage = JSON.parse(window.localStorage.getItem(key) || '[]')

		// // if car was viewed before remove it
		storage = storage.filter(viewed_car => viewed_car.waykeId !== car.waykeId)

		// // limit to last 4
		storage = storage.slice(0, 3)

		// prepend current
		storage.unshift(carSrc)

		// save
		setLastViewedCars(storage)
		window.localStorage.setItem(key, JSON.stringify(storage))
	}

	const featuredImage = () => {
		if (car.featuredImage === null) { return false; }

		// If featuredImage is a string, simply return it.
		if (typeof car.featuredImage === 'string') {
			return car.featuredImage;
		}

		const image = findImageFormat(car.featuredImage, '800x');
		return image[0].src;
	};


	const getCarData = async () => {

		client.get('/car', { params: { id: findIdFromSlug(slug) } })
			.then(results => {								
				// Merge waykeJson data with data
				const featuredImage = results.data.featuredImage; // Save the featuredImage from API.
				const waykeJson = results.data.waykeJson;
				delete results.data.waykeJson;
				const tmpCar = Object.assign(results.data, waykeJson);
				tmpCar.featuredImage = featuredImage; // Restore the featuredImage value from API.

				const tmpPayment = tmpCar.payment;
				if(tmpPayment.residual == null){					
					tmpPayment.residual = {min: 0, max: 0, step: 0, current: 0};
				}				
				setCar(tmpCar)
				setOrder(tmpPayment);
				setCampaigns(tmpCar.campaigns);
				TagManager({data:tmpCar, format:'extended', event: 'ViewContent'});		
			}).catch(err => {
			// Redirect only on 404 error.
			if (err.response && err.response.status === 404) {
				// Redirect to car is sold page.
				if (envVars && envVars.react_app_car_sold_page) {
					window.location.href = envVars.react_app_car_sold_page;
				}
			}
		})
	}

	const getRelatedCarData = async () => {

		client.get('/related', { params: { id: findIdFromSlug(slug) } })
			.then(results => {
				setRelated(results.data.results)
			})
			.catch(err => {
				console.error(err)
			})
	}

	useEffect(() => {

		// clear out eventlisteners using clone
		let searchForm = document.querySelector('input#search')?.parentElement ?? false
		if (!searchForm) { return }

		searchForm.replaceWith(searchForm.cloneNode(true))
		searchForm = document.querySelector('input#search').parentElement

		const searchField = searchForm.querySelector('#search')
		const searchLabel = searchForm.querySelector('label')

		searchLabel.innerHTML = '<span class="strong">Sök bilar</span>';


		const qs = new URLSearchParams(queryString)
		searchField.value = qs.get('query') ?? '';

		if (searchField.value !== '') {
			searchLabel.style = 'display:none';
		} else {
			searchLabel.style = '';
		}

		searchForm.addEventListener('submit', (e) => {
			e.preventDefault();
			const newParams = new URLSearchParams(queryString)
			newParams.set('query', searchField.value)
			history.push('/?' + newParams.toString())
			searchField.blur()

			if (searchField.value !== '') {
				searchLabel.style = 'display:none';
			} else {
				searchLabel.style = '';
			}
		})

	}, [queryString.history])

	useEffect(() => {
		// reset view by clearing car state
		setCar(false)
		getCarData()
		getRelatedCarData()
		window.scrollTo(0, 0)
	}, [slug])

	useEffect(() => {
		if (car) {
			addToLocalStorage(car)
			setEcomData((data) => {
				const vehicleData = {
					id: car._id,
					title: car.title,
					shortDescription: car.shortDescription,
					price: car.price,
					imageUrl: featuredImage(),
					retailerName: 'Bilbolaget',
					modelYear: car.modelYear,
					milage: car.mileage,
					gearBox: car.gearBox,
					fuelType: car.fuelType
				}
				data.vehicle = vehicleData;
				data.serviceLogotypeUrl = 'https://bilbolaget.nu/app/themes/bilbolaget/static/bilbolaget-small.png'
				data.onUserEvent = (userEvent, currentStep) => {
					// Order was created
					if (userEvent === 'ORDER_CREATED' && currentStep === 'FINAL_SUMMARY') {
						TagManager({ event: 'CarEcomConversion' })
					}
				}
				data.onExit = () => {
					setShouldShowEcomModal(false);
					if (breakPoints.max('sm')) {
						imboxToggle().on()
					}
				}
				return data;
			})
		}
	}, [car])


	const renderCar = () => {
		const slugify = (text) => {
			return text.toLowerCase().
					trim().
					replace(/\s+|[^-\w]+/g, '-').
					replace(/-+/g, '-');
		};
		return (
			<>
				<CarContext.Provider value={{ car, order, setOrder, campaigns, tradeIn, setTradeIn, setShouldShowEcomModal, modal, setModal }}>
					<div className="bb-block breadcrumbs">
						<Link to={'/'}>Bilar i lager</Link>
						<span>/</span>
						<Link to={'/' + car.manufacturer}>{car.manufacturer}</Link>
						<span>/</span>
						<Link to={'/' + car.manufacturer + '/' + car.modelSeries}>{car.modelSeries}</Link>
					</div>
					<div className='row'>
						<div className='col first'>

							{car.media &&
								<Gallery media={car.media} car={car} />
							}
							{!car.media &&
								<FeaturedImagePlaceholder />
							}

							<AutokuvaWrapper />

							<h1 className='car-title'>
								{car.title}
							</h1>
							<h3 className="car-description mb-2">{car.shortDescription}</h3>
							<div className='keywords'>
								<Keywords car={car} />
							</div>

							{/* Custom Groups */}
							<div className='section custom-groups'>
							{ car.customGroups && car.customGroups.map((group, index) => (
									<div key={index} className={`custom-group-wrapper ${slugify(group.title)}`}>
										<h3 className="title">{group.title}</h3>
										<p className="description">
											<span dangerouslySetInnerHTML={{ __html: group.description }} />
										</p>
									</div>
							)) }
							</div>

							{ car.deals && <DealsSection carDeals={car.deals} /> }

							{car.keywords.includes('Kampanj') &&
								<div className='section campaigns'>
									<div className="campaign wrapper">
										<h3 className="campaing-title">Just nu är det kampanj på denna bil</h3>
										<p className="campaing-description">Kontakta våra säljare för mer information.</p>
										<a href="#wpforms-section" className="campaing-cta primary">Kontakta säljare</a>
									</div>
								</div>
							}

						</div>
						<div className='col second buying-options'>
							<BuyingOptions car={car} order={order} setShouldShowEcomModal={setShouldShowEcomModal} />
						</div>
						<div className="col">
							{car.description &&
									<Expanding
											label="Visa mer"
											label_expanded="Visa mindre">
										<div className="section">
											<h2 className="section-title">Beskrivning</h2>
											<p className="section-description" style={{ whiteSpace: 'pre-wrap' }}>{car.description}</p>
										</div>
									</Expanding>
							}
							<div className='section'>
								<h2 className="section-title">Biluppgifter</h2>
								<p className="section-description">Information direkt från Transportstyrelsen och tillverkaren.</p>
								<EnhancedProperties />

							</div>

							{car.hasOwnProperty('options') &&
								<Expanding
									callback={(isOpen) => {
										if (!hasTriggeredEquipment) {
											TagManager({ event: 'CarEquipment' })
										}
									}}
									label="Visa mer"
									label_expanded="Visa mindre">
									<div className='section'>
										<h2 className="section-title">Utrustning</h2>
										<div className='details-list'>
											{car.options.map((option, i) => {
												return <span key={i} className="pill">{option}</span>
											})}
										</div>
									</div>
								</Expanding>
							}

                            <BegTest/>
							<Warranty />
                            <UspDetails />

							<div className="section carfax">
								<CarFax />
							</div>

							<div className="section finance" id="lan">
								<h2 className="section-title">Billån</h2>
								<p className="section-description">Hos oss finansierar du din nya bil tryggt och enkelt. Du får rabatt på bilförsäkringen och kan när som helst förtidslösa lånet utan avgifter.</p>
								{order &&
									<LoanCalc />
								}
							</div>

							<div className="section cost">
								<h2 className="section-title">Ägandekostnad</h2>
								<p className="section-description">Det här är en förenklad kalkyl baserad på de uppgifter du har fyllt i.</p>
								<Cost car={car} order={order} />
								<p className="section-description">Kontakta oss för att få en mer exakt beräkning av din totala ägandekostnad och ytterligare information om hur du kan finansiera ditt bilköp.</p>
							</div>
							<div id="wpforms-section">
								<WPBlocks view="single_inside" manufacturer={car.manufacturer} modelSeries={car.modelSeries} fuelType={car.fuelType} gearboxType={car.gearboxType} car_id={car.waykeId} />
							</div>
							<div id="city-section" className="section city">
								<h2 className="section-title">Var står bilen?</h2>
								<p className="section-description">Vi erbjuder köp online med leverans inom hela Sverige.</p>
								<Location />
							</div>
						</div>
					</div>
					{related &&
						<div className='section cars'>
							<h2 className="section-title">Liknande bilar</h2>
							<div className="cars-wrapper">
								{related.map((car, index) => <CarCard key={index} car={car} />)}
							</div>
						</div>
					}
					{lastViewedCars &&
						<div className='section cars'>
							<h2 className="section-title">Senast visade bilar</h2>
							<div className='cars-wrapper'>
								{
									lastViewedCars.map((viewedCar, i) => {
										return <CarCard car={viewedCar} key={i} className='col-3' />
									})
								}
							</div>
						</div>
					}
					{((window.user?.favoritesList ?? false) && window.user.favoritesList.length > 0) &&
						<div className='section cars'>
							<h2 className="section-title">Mina sparade bilar</h2>
							<div className='cars-wrapper'>
								{
									window.user.favorites.map((viewedCar, i) => {
										return <CarCard car={viewedCar} key={`favorite_${i}`} className='col-3' />
									})
								}
							</div>
						</div>
					}
					<CarJSONLD car={car} />
					{/* {shouldShowEcomModal && <Ecom {...ecomData} />} */}
					{/*{shouldShowEcomModal && <WaykeEcomWeb {...ecomData} />}*/}
					{ shouldShowEcomModal && <WaykeEcomWrapper
							car={car}
							onButtonClick={handleWaykeBuyButton}
							onModalClose={handleWaykeModalClose}
					/> }
					{/*<button onClick={() => handleButtonClick()}>Start</button>*/}
					<MobileMenu />
					<InfoModal modal={modal} setModal={setModal} />
					<WPBlocks view="single_after" manufacturer={car.manufacturer} modelSeries={car.modelSeries} fuelType={car.fuelType} gearboxType={car.gearboxType} car_id={car.waykeId} />
				</CarContext.Provider>
			</>
		)
	}

	return (
		<>
			<div className={car ? 'container' : 'container loading'}>{car ? renderCar() : ''}</div>
		</>
	)
}
export default Car
